<template>
  <v-bottom-sheet
      v-model="sheet"
      scrollable
      persistent
      no-click-animation
      :overlay-opacity="0.7"
      content-class="bottom-sheet"
  >
    <v-card>
      <v-card-title class="justify-space-between">
        <v-spacer />
        <v-btn icon @click="$emit('sheetClose')">
          <Close/>
        </v-btn>
      </v-card-title>
      <v-card-text class="d-flex align-center justify-center flex-column pb-0">
        <img :src="getImage('ic_notMatch.svg')">
        <div class="fs-22 mt-6 fw-700 text-body--text">입력한 정보가 일치하지 않습니다.</div>
      </v-card-text>
      <v-card-actions>
        <div class="fill-width text-center">
          <div class="fs-14 secondary--text mb-3 line-height-1">혹시 회원이 아니신가요?</div>
          <BlackBtn x-large str="회원가입 하러가기" :disabled="false" @click="goToLoginPage"/>
        </div>
      </v-card-actions>
    </v-card>
  </v-bottom-sheet>

</template>
<script>
import BlackBtn from "@/components/btns/BlackBtn"
import Close from '@/components/icons/Close'

export default {
  props: {
    sheet: Boolean,
  },
  components: {
    BlackBtn,
    Close,
  },
  methods: {
    goToLoginPage() {
      //this.$router.push({name:'로그인'})
      window.location.href = '/user/login'
    }
  }
}
</script>
